import * as React from 'react';
import { useEffect, useState } from 'react';
import { CreateAppPayload } from './CreateAppPage';
import { FormLayoutWidget } from '../../../widgets/layout/FormLayoutWidget';
import { GroupedButtons } from '../../../widgets/buttons/GroupedButtons';
import { LargeButtonIconWidget } from '../../../widgets/dialog/LargeButtonIconWidget';
import { styled } from '../../../theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CenterFormOrientation, CenterFormWidget } from '../../../widgets/layout/CenterFormWidget';
import { Product } from '@journeyapps-platform/types-accounts';
import { useSystem } from '../../../hooks/useSystem';
import { ProjectFeatureFlags } from '@journeyapps-platform/types-accounts-hub';

const powersync = require('../../../../media/powersync-logo.png');

namespace S {
  const ICON_SIZE = 70;

  export const ProductContainer = styled.div`
    display: flex;
  `;

  export const Icon = styled(FontAwesomeIcon)`
    width: ${ICON_SIZE}px;
    height: ${ICON_SIZE}px;
    color: white;
  `;
}

interface ProjectType {
  key: Product;
  label: string;
  icon: string | JSX.Element;
  beta?: boolean;
  flags: ProjectFeatureFlags[];
}

export const PROJECT_TYPES: ProjectType[] = [
  {
    key: Product.POWERSYNC,
    icon: powersync,
    label: 'PowerSync Project',
    flags: [ProjectFeatureFlags.POWERSYNC]
  },
  {
    key: Product.APP,
    icon: <S.Icon icon="rocket" />,
    label: 'JourneyApps Platform Project',
    flags: [ProjectFeatureFlags.APP]
  }
];

export interface CreateAppStep1WidgetProps {
  org_id: string;
  payload: Partial<CreateAppPayload>;
  next: (payload: Partial<CreateAppPayload>) => any;
  onCancel: () => any;
}

export const CreateAppStep0Widget: React.FC<CreateAppStep1WidgetProps> = (props) => {
  const [selected, setSelected] = useState(props.payload.type);
  const [mapping, setMapping] = useState<{ product: Product; trial: boolean }[]>([]);
  const system = useSystem();
  useEffect(() => {
    let alpha = system.clientProvisioner.provisionAlphaClient();
    Promise.all(
      PROJECT_TYPES.map((p) =>
        alpha
          .proposeApp({
            org_id: props.org_id,
            features: p.flags
          })
          .then((r) => {
            return {
              product: p.key,
              trial: r.trial
            };
          })
      )
    ).then((res) => {
      setMapping(res);
    });
  }, []);

  return (
    <CenterFormWidget
      loading={mapping.length === 0}
      noLogo={true}
      primaryLabel={'Create new project'}
      orientation={CenterFormOrientation.ROW}
    >
      <FormLayoutWidget
        sections={[
          {
            key: 'app_type',
            elements: [
              <S.ProductContainer>
                {PROJECT_TYPES.map((i) => {
                  return (
                    <LargeButtonIconWidget
                      selected={selected === i.key}
                      key={i.key}
                      label={i.label}
                      image={i.icon}
                      beta={i.beta}
                      onSelect={() => {
                        setSelected(i.key as Product);
                      }}
                    />
                  );
                })}
              </S.ProductContainer>
            ]
          },
          {
            key: 'submit',
            elements: [
              <GroupedButtons
                btns={[
                  {
                    label: 'Cancel',
                    action: (event, loading) => {
                      props.onCancel();
                    }
                  },
                  {
                    label: 'Next',
                    disabled: false,
                    action: async (event, loading) => {
                      let trial = mapping.find((m) => m.product === selected)?.trial;
                      const region = system.getRegions(!!trial)[0];
                      props.next({
                        type: selected,
                        trial: trial,
                        region: region
                      });
                    }
                  }
                ]}
              />
            ]
          }
        ]}
      />
    </CenterFormWidget>
  );
};
